/**
 * Shared resources are to be used in both backend and frontend, were sst may not be available
 **/
import Negotiator from 'negotiator';
import { localeToLanguage } from '@worldcoo/shared/core';
import type { Language } from '@worldcoo/shared/core';
import type { CategoryKey } from '@worldcoo/shared/core';

export * from '@worldcoo/shared/core';

/** Category key → percentage. Keys must be valid CategoryKey values. */
export type Allocations = Partial<Record<CategoryKey, number>>;

export const channelTypes = ['Corporate', 'Tpv', 'Widget', 'API', 'Custom'] as const;

export type ChannelType = (typeof channelTypes)[number];

export enum merchantOrigin {
	backoffice,
	onboarding,
	onboardingMagento,
	onboardingPrestashop,
	onboardingTpv,
}
export const WORLDCOO_MERCHANT_ID = '997d0641-65ab-4897-9719-e4977f733527';

export function localeToLang(locale: string): Language | undefined {
	const normalizedLocale = locale.trim().toLowerCase();
	return localeToLanguage[normalizedLocale as keyof typeof localeToLanguage];
}

export class CoreDomainError extends Error {}

export class EntityVersionConflictError extends CoreDomainError {
	constructor() {
		super('Entity version conflict');
	}
}

export type DocumentType = 'id' | 'taxId' | 'passport' | 'nie' | 'others';

export function detectLocale<T extends string>(acceptLanguage: string | null, availableLocales: readonly T[]): T {
	if (!acceptLanguage) return 'es' as T;
	const negotiator = new Negotiator({ headers: { 'accept-language': acceptLanguage } });
	return (negotiator.language(availableLocales as unknown as string[]) ?? 'es') as T;
}
